import { Link } from "react-router";
import { workabilityLabel } from "@capture/shared";

/**
 * DE-1545 F-046 — discoverability for batches awaiting supervisor release.
 *
 * Held bundles live on Operations → Pending Release (`/pending-release`), but a
 * supervisor watching the Queue Dashboard had no pointer to them. This small
 * indicator surfaces the count and links straight to that surface. Renders
 * nothing when there is nothing awaiting release.
 */
export function PendingReleaseIndicator({ count }: { count: number }) {
  if (count <= 0) return null;
  return (
    <Link
      to="/pending-release"
      className="queue-pending-release"
      data-testid="pending-release-indicator"
      title="Batches held for supervisor release"
    >
      <span className="queue-pending-release-count">{count}</span>
      {workabilityLabel("awaiting_release")}
    </Link>
  );
}
